import http from "../http-common";

// used in BookList.jsx, CreatorList.jsx, DomainList.jsx
const getAll = () => {
  return http.get("/domains");
};

// used in MaterialAddBook.jsx, CategoryList.jsx
const getAllMin = () => {
  return http.get("/domains/min");
};

// const get = (id) => {
//   return http.get(`/domains/${id}`);
// };

// used in DomainList.jsx
const create = (data) => {
  return http.post("/domains", data);
};

// used in DomainItem.jsx
const update = (id, data) => {
  return http.put(`/domains/${id}`, data);
};

// used in DomainItem.jsx
const remove = (id) => {
  return http.delete(`/domains/${id}`);
};

// const getFields = (id) => {
//   return http.get(`/domains/${id}/fields`);
// };

// const removeField = (id) => {
//   return http.delete(`/domains/fields/${id}`);
// };

// const createField = (domainId, field) => {
//   return http.post(`/domains/${domainId}/fields`, field);
// };

// commented out in DomainList.jsx
// const getAllFields = () => {
//   return http.get(`/domains/fields`);
// };

// const addFieldsToDomain = (domainId, fieldIds) => {
//   return http.post(`/domains/${domainId}/fields`, fieldIds);
// };

// const getDomainName = (domainId) => {
//   return http.get(`/domains/${domainId}/name`);
// };

// used in DomainUserModals.jsx
const getUserData = (domainId) => {
  return http.get(`/domains/${domainId}/userData`);
};

const DomainService = {
  getAll,
  // get,
  create,
  update,
  remove,
  // getFields,
  // addFieldsToDomain,
  // removeField,
  // getAllFields,
  // getDomainName,
  getAllMin,
  getUserData,
};

export default DomainService;
